<template>
  <v-container>
    <v-text-field
      prefix="Nombre: "
      single-line
      v-model="propertyPage.name"
    />

    <v-checkbox
      class="mb-5"
      label="Página principal"
      v-model="propertyPage.main"
      :disabled="propertyPage.main"
      hide-details
    ></v-checkbox>

    <v-text-field
      prefix="z:"
      v-model="propertyPage.z_index"
      type="number"
    ></v-text-field>

    <v-file-input
      v-if="!propertyPage.background_image || propertyPage.background_image == null"
      accept="image/*"
      label="Imagen de fondo"
      v-model="uploaded_image"
      @change="updateBackgroundImage"
    >
    </v-file-input>

    <v-btn
      v-else
      block
      outlined
      class="mb-5"
      text
      color="primary"
      @click="propertyPage.background_image = null"
    >
      Cambiar imagen
    </v-btn>

    <v-btn
      block
      @click="show_confirmation_card = true"
      color="error"
    >
      Eliminar
    </v-btn>
    <v-dialog
      v-model="show_confirmation_card"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-card-title>Confirmación</v-card-title>
        <v-card-text> ¿Estás seguro de que deseas eliminar esta página? </v-card-text>

        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="deleteCurrentPage"
          >
            Eliminar
          </v-btn>
          <v-btn
            color="primary"
            outlined
            text
            @click="show_confirmation_card = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      show_confirmation_card: false,
      uploaded_image: null,
    };
  },

  computed: {
    ...mapState(["pages"]),

    propertyPage() {
      return this.actualPage();
    },
  },

  methods: {
    ...mapGetters(["activePages", "actualPage"]),
    ...mapActions(["deletePage", "changePageName"]),

    ...mapActions(["api", "putBackground"]),

    deleteCurrentPage() {
      this.deletePage();
      this.show_confirmation_card = false;
    },

    updateBackgroundImage() {
      if (this.uploaded_image != null) {
        const reader = new FileReader();
        reader.readAsDataURL(this.uploaded_image);
        reader.onload = () => {
          this.putBackground(reader.result);
        };
        reader.onerror = (error) => {
          console.error("Error al leer el archivo:", error);
        };
      }
    },
  },
};
</script>
